import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import Checkbox from "@mui/material/Checkbox";

// const data = [
//   {
//     id: 0,
//     value: null,
//     isChecked: false,
//     isEditing: false,
//   },
//   // {
//   //     id: 1,
//   //     value: null,
//   //     isChecked: true,
//   //     isEditing: false
//   // },
//   // {
//   //     id: 2,
//   //     value: null,
//   //     isChecked: true,
//   //     isEditing: false
//   // }
// ];
export default function Checks(props) {
  const [ElemData, setElemData] = useState([]);
  const [data, setData] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const popOpen = anchorEl;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const _handlePopoverOpen = (event, i) => {
    setAnchorEl(event.currentTarget);
  };

  const _handlePopoverClose = (e, i, value = null) => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    setElemData(data);
  }, []);
  return (
    <div>
      <Checkbox
        onClick={(e) => _handlePopoverOpen(e)}
        size="small"
        checked={props.value == 0 || props.value == 1}
        checkedIcon={
          props.value == 1 ? (
            <CheckIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )
        }
      />
      <Popover
        open={popOpen}
        anchorEl={anchorEl}
        onClose={(e) => _handlePopoverClose(e)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box sx={{ border: 0, p: 1, bgcolor: "background.paper" }}>
          <Stack spacing={2} direction="row">
            <Button
              variant="contained"
              color="success"
              onClick={(e) => {
                _handlePopoverClose(e);
                props._handleClickYes();
              }}
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={(e) => {
                _handlePopoverClose(e);
                props._handleClickNo();
              }}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Popover>
    </div>
  );
}
